export enum StatusType {
  Info = 'Info',
  Success = 'Success',
  Warning = 'Warning',
  Error = 'Error',
  Delete = 'Delete',
  Inactive = 'Inactive',
  Custom = 'Custom',
}
